import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await api.get("/content");
      setData(res.data);
      setError(null);
    } catch (e) {
      setError(e?.message || "Error");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return <SiteContext.Provider value={{ data, loading, error, refresh: load }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);

export function openStatus(hours) {
  if (!hours || !hours.length) return { open: false };
  try {
    const now = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Chicago" }));
    const day = now.getDay();
    const mins = now.getHours() * 60 + now.getMinutes();
    for (const h of hours) {
      if ((h.days || []).includes(day)) {
        const [oh = 0, om = 0] = (h.open || "").split(":").map(Number);
        const [ch = 0, cm = 0] = (h.close || "").split(":").map(Number);
        return { open: mins >= oh * 60 + om && mins < ch * 60 + cm };
      }
    }
    return { open: false };
  } catch {
    return { open: false };
  }
}
